export default __webpack_public_path__ + "static/img/Letinte70.66a17a4.jpg";